module.exports = __webpack_public_path__ + "img/news_poster1.3eedda62.jpg";